module.exports = __webpack_public_path__ + "assets/images/icon-pin-cluster.92cbfcac.svg";